// Origin + path + hash *path*, with any query dropped. On Billy's hash-router URLs the route lives in
// the hash, so a naive `href.split('?')[0]` would truncate at a pre-hash `?` and drop the whole route
// (Stripe would then return to a page where the OAuth callback never mounts). Splitting the hash on
// its own `?` keeps the route while stripping only its query.
export const getCleanReturnUrl = (): string => {
  const { origin, pathname, hash } = window.location

  return `${origin}${pathname}${hash.split('?')[0]}`
}
